/** @jsx isolateComponent */

import { Fragment } from 'react';
import { isolateComponent } from '@zapier/common-utils';
import { Text } from '@zapier/design-system';

type PlanTitleProps = {
  description?: string | null;
  title: string;
};

/**
 * A component that displays a specified plan's title and description.
 */
export const PlanTitle = ({ description, title }: PlanTitleProps) => (
  <Fragment>
    <Text color="grey900" fontWeight={700} tag="h2" type="subtitle900">
      {title}
    </Text>

    {description && (
      <Text color="grey700" tag="p" type="altText900">
        {description}
      </Text>
    )}
  </Fragment>
);
